// extracted by mini-css-extract-plugin
module.exports = {"hide-tour-button":"styles_hide-tour-button__2IkMx"};